module.exports = __webpack_public_path__ + "static/media/insight1.9fc7546d.jpg";